import React, { Component } from 'react';

import { navigate, RouteComponentProps } from '@reach/router';

import { IErrorsActions } from '../../../../store/errors/actions';
import { INotificationsActions } from '../../../../store/notification/actions';
import { IClubsActions } from '../../../../store/player/clubs/actions';
import { IMembershipsActions } from '../../../../store/player/memberships/actions';
import { IProfileActions } from '../../../../store/user/actions';
import { IMessageNotification } from '../../../../store/notification/store';
import { IClubsStore } from '../../../../store/player/clubs/store';
import { ISource, IStripeToken, IUserStore } from '../../../../store/user/store';

import JoinClubCta from '../../../../components/JoinClubCta';
import PaymentManager from '../../../../components/PaymentManager';
import { withContext } from '../../../../contrib/utils';
import clubLogo from '../../../../assets/images/club-logo.svg';
import { redWaglLogo } from '../../../../assets/images/';

interface IProps extends RouteComponentProps {
  actions: {
    clubs: IClubsActions;
    errors: IErrorsActions;
    memberships: IMembershipsActions;
    notifications: INotificationsActions;
    user: IProfileActions;
  };
  clubId: number;
  clubs: IClubsStore;
  user: IUserStore;
}

export class NewClubPayComponent extends Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);

    this.next = this.next.bind(this);
  }

  public componentDidMount(): void {
    this.props.actions.clubs.get(this.props.clubId);
  }

  public async next(clubId: number, payment?: IStripeToken | ISource): Promise<any> {
    const { actions } = this.props;
    const response = await actions.memberships.create(clubId, payment);

    if (response.errors) {
      await actions.notifications.push(({
        status: 'unread',
        text: response.errors.memberships.msg,
        type: 'error'
      } as unknown) as IMessageNotification);
    } else {
      navigate(`/club/${clubId}`);
    }
  }

  public render(): JSX.Element {
    const { clubs, user } = this.props;
    const club = clubs[Number(this.props.clubId)];

    return (
      <div className="new-club-pay">
        {!!club ? (
          club.processPayment ? (
            <>
              <img
                alt="Club Logo"
                className="new-club-pay__club-logo"
                src={club.profileImage || clubLogo}
              />
              <div className="new-club-pay__powered">
                powered by <img src={redWaglLogo} alt="Wagl Logo" />
              </div>
              <h1 className="new-club-pay__title">Club Fees Due Today</h1>
              <div className="new-club-pay__fee">$ {club.membershipPrice}</div>
              <h2 className="new-club-pay__subtitle">ENTER CREDIT CARD INFORMATION</h2>
              <PaymentManager
                actions={this.props.actions}
                clubId={this.props.clubId}
                user={user}
                nextButton={'NEXT'}
                next={this.next}
              />
            </>
          ) : (
            <JoinClubCta club={club} clubId={this.props.clubId} next={this.next} />
          )
        ) : null}
      </div>
    );
  }
}

const NewClubPay = withContext(NewClubPayComponent, 'user', 'clubs');

export { NewClubPay };
